import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "src/utils/api";
import { StatusCodes } from "http-status-codes";
import { GET_OWNER } from "../actions/OwnerAction";
import {
  fetchOwnerListFailure,
  fetchOwnerListSuccess,
} from "../slices/OwnerSlice";
import notification from "antd/es/notification";

export function* fetchOwnerSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK)
      yield put(fetchOwnerListSuccess(result));
    else {
      yield put(fetchOwnerListFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchOwnerListFailure(error.message));
  }
}

export default function* ownerdetailsSaga() {
  yield all([takeLatest(GET_OWNER, fetchOwnerSaga)]);
}
